// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3NzhE","buttons":"SendReceipts_buttons__2cBCK","email":"SendReceipts_email__9mhUL","bookApptTitle":"SendReceipts_bookApptTitle__2uQLo"};